import { gql, useMutation } from '@apollo/client';

import type {
  SetRemittanceWireDetails,
  SetRemittanceWireDetailsVariables,
} from './__generated__/SetRemittanceWireDetails';
import { GET_DEAL_MONTH_REMITTANCES } from './getDealMonthRemittances_gql';

/**
 * Updates wire details and/or confirmation flags on a deal-month remittances snapshot.
 * Omitted fields are left untouched server-side. Requires existing_version for optimistic locking;
 * a stale version returns an error and the caller should refetch before retrying.
 */
export const SET_REMITTANCE_WIRE_DETAILS = gql`
  mutation SetRemittanceWireDetails($input: SetRemittanceWireDetailsInput!) {
    setRemittanceWireDetails(input: $input) {
      payment_month
      version
      buyer_wire_details {
        account_name
        account_number
        bank_name
        routing_number
      }
      seller_wire_details {
        account_name
        account_number
        bank_name
        routing_number
      }
      buyer_remittances_received
      seller_remittances_sent
    }
  }
`;

export function useSetRemittanceWireDetails() {
  return useMutation<SetRemittanceWireDetails, SetRemittanceWireDetailsVariables>(
    SET_REMITTANCE_WIRE_DETAILS,
    {
      refetchQueries: [GET_DEAL_MONTH_REMITTANCES],
      awaitRefetchQueries: true,
    },
  );
}
